document.addEventListener('DOMContentLoaded', function () {
  var panels = document.querySelectorAll('.category-panel');

  var activePanel = null;
  var activeTrigger = null;
  var closeTimer = null;

  var GROW_MS = 320;
  var FLIP_MS = 380;
  var FADE_MS = 220;


  /* =======================================================
     MOVER PAINÉIS PARA O BODY
     ======================================================= */

  panels.forEach(function (panel) {
    document.body.appendChild(panel);
  });


  /* =======================================================
     BODY SCROLL
     ======================================================= */

  function lockBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  function unlockBodyScroll() {
    document.body.style.overflow = '';
  }


  /* =======================================================
     RESET
     ======================================================= */

  function resetPanel(panel) {
    if (!panel) {
      return;
    }

    var content = panel.querySelector(
      '.category-panel__content'
    );

    var flip = panel.querySelector(
      '.category-panel__flip'
    );

    panel.classList.remove('is-open');
    panel.classList.remove('is-closing');
    panel.classList.remove('is-interactive');

    panel.dataset.closing = 'false';


    if (content) {
      content.style.transform = '';
      content.style.transition = '';
    }


    if (flip) {
      flip.classList.remove('is-flipped');
      flip.style.transition = '';
    }
  }


  /* =======================================================
     FECHAR
     ======================================================= */

  function closePanel(panel, trigger) {
    if (!panel || panel.hidden) {
      return;
    }

    if (panel.dataset.closing === 'true') {
      return;
    }

    panel.dataset.closing = 'true';


    if (trigger) {
      trigger.setAttribute(
        'aria-expanded',
        'false'
      );
    }


    /*
      Remove imediatamente a camada interativa.

      O cartão não faz reverse animation.
      O painel simplesmente desaparece com fade.
    */

    panel.classList.remove(
      'is-interactive'
    );

    panel.classList.add(
      'is-closing'
    );


    clearTimeout(closeTimer);


    closeTimer = setTimeout(function () {

      panel.hidden = true;

      resetPanel(panel);


      if (activePanel === panel) {
        activePanel = null;
        activeTrigger = null;
      }

      unlockBodyScroll();

    }, FADE_MS + 40);
  }


  /* =======================================================
     ATIVAR INTERAÇÃO
     ======================================================= */

  function activateInteraction(panel) {
    if (!panel) {
      return;
    }

    if (panel.hidden) {
      return;
    }

    if (panel.dataset.closing === 'true') {
      return;
    }

    if (activePanel !== panel) {
      return;
    }


    /*
      Esperamos um frame de composição.

      Isto impede que o browser mostre durante um frame
      o conteúdo do verso 3D antes da camada 2D estar
      completamente composta.
    */

    requestAnimationFrame(function () {

      if (panel.hidden) {
        return;
      }

      if (panel.dataset.closing === 'true') {
        return;
      }

      if (activePanel !== panel) {
        return;
      }

      panel.classList.add(
        'is-interactive'
      );

    });
  }


  /* =======================================================
     ABRIR
     ======================================================= */

  function openPanel(panel, trigger) {
    if (!panel || !trigger) {
      return;
    }


    /*
      Se existir outro painel aberto,
      fecha-o primeiro.
    */

    if (
      activePanel &&
      activePanel !== panel
    ) {
      closePanel(
        activePanel,
        activeTrigger
      );
    }


    clearTimeout(closeTimer);


    var content = panel.querySelector(
      '.category-panel__content'
    );

    var flip = panel.querySelector(
      '.category-panel__flip'
    );


    if (!content || !flip) {
      return;
    }


    activePanel = panel;
    activeTrigger = trigger;


    panel.dataset.closing = 'false';


    /*
      Estado inicial.
    */

    panel.hidden = false;

    panel.classList.remove(
      'is-closing'
    );

    panel.classList.remove(
      'is-interactive'
    );


    flip.classList.remove(
      'is-flipped'
    );


    /*
      Desligamos temporariamente as transições
      para preparar o primeiro frame.
    */

    flip.style.transition = 'none';

    content.style.transition = 'none';


    content.style.transform =
      'translate(-50%, -50%) scale(0.45)';


    /*
      Força o browser a aplicar o estado inicial
      antes de começar a animação.
    */

    void content.offsetWidth;


    lockBodyScroll();


    panel.classList.add(
      'is-open'
    );


    /*
      GROW
    */

    content.style.transition =
      'transform ' +
      GROW_MS +
      'ms cubic-bezier(0.22, 1, 0.36, 1)';


    requestAnimationFrame(function () {

      content.style.transform =
        'translate(-50%, -50%) scale(1)';

    });


    /*
      Depois do crescimento começa a rotação.
    */

    setTimeout(function () {

      if (panel.hidden) {
        return;
      }

      if (panel.dataset.closing === 'true') {
        return;
      }

      if (activePanel !== panel) {
        return;
      }


      flip.style.transition =
        'transform ' +
        FLIP_MS +
        'ms cubic-bezier(0.4, 0, 0.2, 1)';


      flip.classList.add(
        'is-flipped'
      );


      /*
        IMPORTANTE:

        Não adicionamos atrasos artificiais
        depois da rotação.

        Assim que o FLIP terminou, ativamos
        a camada 2D.
      */

      setTimeout(function () {

        activateInteraction(panel);

      }, FLIP_MS);

    }, GROW_MS);


    trigger.setAttribute(
      'aria-expanded',
      'true'
    );
  }


  /* =======================================================
     CATEGORIAS
     ======================================================= */

  document
    .querySelectorAll('.category-tile')
    .forEach(function (tile) {

      var trigger = tile.querySelector(
        '.category-tile__trigger'
      );


      if (!trigger) {
        return;
      }


      /* ===================================================
         CATEGORIA SEM SUBCATEGORIAS
         =================================================== */

      if (
        trigger.classList.contains(
          'category-tile__trigger--direct'
        )
      ) {

        trigger.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();


            var url = tile.getAttribute(
              'data-main-url'
            );


            if (!url) {
              return;
            }


            window.location.assign(url);

          }
        );


        return;
      }


      /* ===================================================
         CATEGORIA COM SUBCATEGORIAS
         =================================================== */

      if (
        trigger.tagName !== 'BUTTON'
      ) {
        return;
      }


      var index = tile.getAttribute(
        'data-index'
      );


      var panel = document.querySelector(
        '.category-panel[data-index="' +
        index +
        '"]'
      );


      if (!panel) {
        return;
      }


      /* ===================================================
         ABRIR
         =================================================== */

      trigger.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();


          openPanel(
            panel,
            trigger
          );

        }
      );


      /* ===================================================
         FECHAR
         =================================================== */

      var closeButton = panel.querySelector(
        '.category-panel__close'
      );


      if (closeButton) {

        closeButton.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();


            closePanel(
              panel,
              trigger
            );

          }
        );

      }


      /* ===================================================
         BACKDROP
         =================================================== */

      var backdrop = panel.querySelector(
        '.category-panel__backdrop'
      );


      if (backdrop) {

        backdrop.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();


            closePanel(
              panel,
              trigger
            );

          }
        );

      }

    });


  /* =======================================================
     ESC
     ======================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key !== 'Escape') {
        return;
      }

      if (!activePanel) {
        return;
      }


      closePanel(
        activePanel,
        activeTrigger
      );

    }
  );

});